import { AppRouter } from "@components/App/AppRouter";
import { swrConfig } from "@libs/swr/swr";
import { SWRConfig } from "swr";

export const App = () => (
  <SWRConfig value={swrConfig}>
    <AppRouter />
  </SWRConfig>
);
